/**
 * A tab is stale once an upgrade removed code it still needs: a lazy import failed to load
 * (Vite's `vite:preloadError`, or a `LazyImportBoundary` caught the failure). `ReloadWhenStale`
 * then turns the next in-app navigation into a full page load of the release now running.
 */
let stale = false;

export function markTabStale() {
    stale = true;
}

export function isTabStale() {
    return stale;
}
